import script from "./SendNotification.vue?vue&type=script&setup=true&lang=js"
export * from "./SendNotification.vue?vue&type=script&setup=true&lang=js"

import "./SendNotification.vue?vue&type=style&index=0&id=cf179f58&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-cf179f58"]])

export default __exports__